import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, MasterData } from '@card-software/library';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MasterDataProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/master-data';

  searchByCode(code: string): Observable<ApiResponse<MasterData>> {
    return this.httpClient.post<ApiResponse<MasterData>>(`${this.baseUrl}/search`, { code });
  }

  /**
   * Every master-data entry in the given categories, in one call. Used by the AP document form (#4842) to
   * populate the ItemClassification picker for description-only lines — the categories are short catalogs, so
   * this is fetched once per form rather than per line.
   */
  getByCategoryCodes(categoryCodes: string[]): Observable<ApiResponse<MasterData[]>> {
    return this.httpClient.post<ApiResponse<MasterData[]>>(`${this.baseUrl}/batch/category-codes`, categoryCodes);
  }
}
